module.exports = __webpack_public_path__ + "img/me.da0d8023.jpg";